import React from 'react';

import type {EntityStoreUser} from 'constants/EntityStoreConstants';
import HomeDashboardActions from 'home-dashboard/HomeDashboardActions';
import HomeDashboardStore from 'home-dashboard/HomeDashboardStore';
import SearchOrganizationModal from 'orgs/SearchOrganizationModal';
import EntityStore from 'stores/EntityStore';
import ModalAnchor from 'ui-library/ModalAnchor';

interface AnchorModalsForOnboardingProps {
  openModal: string | null;
}

const handleCloseSearchOrgModal = (): void => {
  HomeDashboardActions.closeSearchOrgModal();
};

function AnchorModalsForOnboarding({openModal}: AnchorModalsForOnboardingProps): JSX.Element {
  const currentUser: EntityStoreUser | null = EntityStore.currentUser();

  return (
    <div>
      {currentUser && (
        <div>
          <ModalAnchor open={openModal === HomeDashboardStore.SEARCH_ORGANIZATION_MODAL_KEY}>
            <SearchOrganizationModal currentUser={currentUser} onRequestClose={handleCloseSearchOrgModal} />
          </ModalAnchor>
        </div>
      )}
    </div>
  );
}

export default AnchorModalsForOnboarding;
